module.exports = {
    DetectFlex: require('./detect-flex'),
    DetectIE: require('./detect-ie'),
    QueryString: require('./queryString'),
};



// WEBPACK FOOTER //
// /home/eric/projects/com.strongproject/repos/platforms/common-js/helpers/helpers.js